<template>
  <div class="table-page-wrapper">

    <div v-show="searchStatus" class="search-wrapper">
      <search-channel-select v-model="tableParams.channelId" />
      <el-input v-model="tableParams.appBundle"  placeholder="应用包名或编号或名称" />
      <el-select
        v-model="tableParams.isEnable"
        clearable
        filterable

        placeholder="审核状态"
        style="margin-right: 15px;width: 110px">
        <el-option v-for="item in statusList" :label="item.lable" :value="item.value" :key="item.value" />
      </el-select>
      <el-button @click="toQuery" type="primary" >搜索</el-button>
    </div>

    <div class="table-wrapper">
      <table-column
        @search="searchColumn"
        @refresh="toQuery"
        @change="changeColumn"
        :column="columns"
        style="padding-bottom: 10px;">
        <el-button
          @click="handleBatchAudit"
          type="success"
          size="mini">
          批量审核
        </el-button>
        <el-button @click="handleAdd()" type="primary" size="small">新增应用</el-button>
      </table-column>

      <el-table
        v-loading="tableLoading"
        :data="tableData"
        height="80vh"
        @selection-change="handleTableSelectionChange"
        :header-cell-style="{background:'#fafafa'}"
        highlight-current-row
        size="small"
        ref="table"
        class="js-table"
        style="width: 100%">
          <el-table-column type="selection"></el-table-column>
          <el-table-column
            v-for="(v, i) in checkColumns"
            :prop="v.field"
            :label="v.title"
            :width="v.width"
            :min-width="v.minWidth"
            :key="i"
            align="center">
            <template v-slot="scope">
              <span v-if="v.field === 'isEnable'">{{ statusMap[scope.row[v.field]] || '-' }}</span>
              <span v-else-if="v.field === 'appType'">{{ appTypeMap[scope.row[v.field]] || '-' }}</span>
              <span v-else-if="v.field === 'appUrl'">
                <el-popover
                placement="top-start"
                trigger="click"
                ref="popover">
                <template #reference >
                  <div>查看</div>
                </template>
                <div>{{scope.row[v.field]|| '-' }}</div>
              </el-popover>
              </span>
              <span v-else>{{ scope.row[v.field] }}</span>
            </template>
          </el-table-column>
          <el-table-column label="审核" fixed="right" align="center" width="100">
            <template v-slot="scope" align="center">
              <el-button @click="handleAudit(scope.row)"  :type="mapType(scope.row.isEnable)" size="mini">{{getstatus(scope.row.isEnable)}}</el-button>
           </template>
          </el-table-column>
          <el-table-column label="编辑" fixed="right" align="center" width="100">
            <template v-slot="scope" align="center">
              <el-button @click="handleUpdate(scope.row)" type="primary" size="mini">编辑</el-button>
            </template>
          </el-table-column>
      </el-table>

      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :total="pagination.total"
        :pager-count="6"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :page-sizes="[10, 30, 60]"
        background
        layout="total,sizes,prev,pager,next"
        style="margin-top: 40px;" />
    </div>

    <el-dialog
      v-model="dialogStatus"
      :close-on-click-modal="false"
      @close="dialogClose"
      title="应用审核"
      :width="500"
      append-to-body>
      <el-form ref="form" label-width="90px">
        <el-form-item label="应用信息">
          <el-tag
            v-for="(item, index) in auditForm.appIds"
            @close="deleteAppId(index)"
            :key="item.appId"
            :closable="auditForm.appIds.length > 1"
            size="mini"
            style="margin-right: 10px;">
              <p>应用名称：{{ item.appName }}</p>
              <p>应用包名：{{item.appBundle}}</p>
          </el-tag>
        </el-form-item>
        <el-form-item label="审核描述">
          <el-input v-model="auditForm.auditDesc" type="textarea"  placeholder="审核描述" />
        </el-form-item>
      </el-form>

      <div style="text-align: right;">
        <el-button @click="auditSubmit(1)" type="warning" >审核不通过</el-button>
        <el-button @click="auditSubmit(0)" type="primary" >审核通过</el-button>
      </div>
    </el-dialog>

    <m-form @submit="toQuery" ref="form" title="应用 " />

  </div>
</template>

<script>
import SearchChannelSelect from '@/components/SearchChannelSelect'
import TableColumn from '@/components/TableColumn'
import mForm from './form'
import initTableMixin from '@/mixins/initTable'

import { auditApp } from '@/api/manage/channel/app'
import { appTypeMap } from '@/const/app-type'

export default {
  name: 'Manage/channel/app',
  components: {
    SearchChannelSelect,
    TableColumn,
    mForm
  },
  mixins: [initTableMixin],
  data () {
    return {
      tableSelect: [],
      columns: [
        { field: 'appName', title: '应用名称' },
        { field: 'appBundle', title: '应用包名' },
        { field: 'channelName', title: '渠道名称' },
        { field: 'isEnable', title: '审核状态' },
        { field: 'appType', title: '系统类型' },
        { field: 'appUrl', title: '下载地址' },
        { field: 'auditDesc', title: '描述' },
        { field: 'createTime', title: '创建时间' }
      ],
      statusList: [
        { value: 0, lable: '审核通过' },
        { value: 1, lable: '未通过' },
        { value: 2, lable: '未审核' }
      ],
      statusMap: {
        0: '审核通过',
        1: '未通过',
        2: '未审核'
      },
      appTypeMap: appTypeMap,

      dialogStatus: false,
      auditForm: {
        appIds: [],
        auditDesc: undefined
      }
    }
  },
  created () {},
  mounted () {
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    beforeInit () {
      this.tableUrl = '/endApp/appAdmin'
      return true
    },
    handleAdd () {
      this.$refs.form.show()
    },
    handleUpdate (row) {
      this.$refs.form.show(row)
    },
    handleAudit (row) {
      this.dialogStatus = true
      this.auditForm.appIds = [row]
    },
    handleTableSelectionChange (selection) {
      this.tableSelect = selection
    },
    handleBatchAudit () {
      this.dialogStatus = true
      this.auditForm.appIds = this.tableSelect
    },
    auditSubmit (status) {
      const form = {};
      form.auditDesc = this.auditForm.auditDesc || undefined
      form.isEnable = status
      form.appId = this.auditForm.appIds.map(item => {
        return item.appId
      }).join(',')
      auditApp(form).then(res => {
        if (res.code === 200) {
          this.resetForm()
        }
      })
    },
    resetForm () {
      this.auditForm = {
        appIds: [],
        auditDesc: undefined
      }
      this.$refs.table.clearSelection()
      this.init()
      this.dialogStatus = false
    },
    deleteAppId (index) {
      this.auditForm.appIds.splite(index, 1)
    },
    dialogClose () {
      this.dialogStatus = false
    },
    mapType(value){
      if(value==2){
        return "primary"
      }else if(value==1){
        return "danger"
      }else{
        return "success"
      }
    },
    getstatus(value){
      if(value==2){
        return "未审核"
      }else if(value==1){
        return "未通过"
      }else{
        return "已通过"
      }
    }
  }
}
</script>

<style scoped lang="scss">
.search-wrapper{
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: #ffffff;
  &>*{
    margin-right: 15px;
    margin-bottom: 10px;
    &:last-child{
      margin-right: 0;
    }
  }

  &>.el-select,&>.el-input{
    width: 220px;
  }
}

.table-wrapper{
  padding: 15px;
  background: #ffffff;
  .table__operation{
    padding-bottom: 10px;
  }
}

.el-table::before {
  height: 0;
}

.el-pagination {
  text-align: right;
}
.el-tag{
    white-space: normal;
    height:auto;
}
</style>
